/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { EXPLORE_SECTION_MESSAGE_DISMISSED } from '../../../constants.tsx';
import type { Props, State } from '../../../types.tsx';
import { maybeWaitForPremiumModal } from '../../utils.tsx';

export const loadExploreSectionMessageDismissed =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		await maybeWaitForPremiumModal(getState);

		// User property is already loaded
		if (typeof getState().projectFields.exploreSectionMessageDismissed === 'boolean') {
			return;
		}

		try {
			const exploreSectionMessageDismissed = await getUserProperty<boolean>(
				accountId,
				EXPLORE_SECTION_MESSAGE_DISMISSED,
			);

			const state = getState();

			setState({
				...state,
				projectFields: {
					...state.projectFields,
					exploreSectionMessageDismissed,
				},
			});
		} catch (error) {
			// Expected error, the property is not set yet
			if (error instanceof FetchError && error.statusCode === 404) {
				const state = getState();

				setState({
					...state,
					projectFields: {
						...state.projectFields,
						exploreSectionMessageDismissed: false,
					},
				});

				return;
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.project-fields.explore-section-message',
				`Failed to get user property with key: ${EXPLORE_SECTION_MESSAGE_DISMISSED}`,
				error instanceof Error ? error : undefined,
			);
		}
	};

export const setExploreSectionMessageDismissed =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		const state = getState();

		setState({
			...state,
			projectFields: {
				...state.projectFields,
				exploreSectionMessageDismissed: true,
			},
		});

		try {
			await setUserProperties(accountId, EXPLORE_SECTION_MESSAGE_DISMISSED, 'true');
		} catch (error) {
			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.project-fields.explore-section-message',
				`Failed to set user property with key: ${EXPLORE_SECTION_MESSAGE_DISMISSED}`,
				error instanceof Error ? error : undefined,
			);
		}
	};
